import Card from "./components/Card/Card";
import CardsProps from "./CardsProps.interface";
import Carousel from "./components/Carousel/Carousel";
import setStyles from "./helpers/setStyles";
import styles from "./Cards.module.scss";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import React, { FunctionComponent } from "react";
import useAnchor from "blocks/hooks/useAnchor";
import useBoxWrap from "blocks/hooks/useBoxWrap";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const Cards: FunctionComponent<CardsProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const [boxWrapClasses, boxWrapStyles] = useBoxWrap(props.settings.cardBoxWrap);

    const { containerStyles, containerClasses } = setStyles(props.settings, styles);
    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    return (
        <section className={combineClasses(styles.wrapper, ...containerClasses, ...splitClasses, ...wrapperClasses, ...boxWrapClasses)} style={{ ...wrapperStyles, ...containerStyles, ...splitStyles, ...boxWrapStyles }} id={identifier}>
            {/* Cards */}
            {props.content.cards && props.content.cards.length > 0 ? (
                <Carousel>
                    {props.content.cards.map((item, index) => {
                        return (
                            <Card key={index} {...item} settings={props.settings} />
                        );
                    })}
                </Carousel>
            ) : null}

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default Cards;